<div class="lv-login-box">
  <div class="lv-login-box__header"></div>
  <form class="lv-login-box__form" [formGroup]="form" (ngSubmit)="resetPassword()">
    <div class="lv-login-box__title" translate>reset-password.title</div>

    @if (errorMessage) {
      <div class="error-message">{{ errorMessage }}</div>
    }

    <div class="field">
      <div class="control has-icon">
        <input
          type="password"
          formControlName="password"
          lvI18nPlaceholder="reset-password.new-password-placeholder"
          class="input"
          [disabled]="loading"
        />
        <span class="icon">
          <i lvIcon="asterisk"></i>
        </span>
      </div>
    </div>

    <div class="field">
      <div class="control has-icon">
        <input
          type="password"
          formControlName="passwordConfirmation"
          lvI18nPlaceholder="reset-password.confirm-password-placeholder"
          class="input"
          [disabled]="loading"
        />
        <span class="icon">
          <i lvIcon="asterisk"></i>
        </span>
      </div>
    </div>

    <button class="button" [disabled]="loading" translate>
      {{ loading ? 'app.connecting' : 'reset-password.submit' }}
    </button>
  </form>
</div>

<lv-copyright></lv-copyright>
